/**
 * The checkbox input component
 */
const themeCheckboxComponent = {
  variants: {
    rounded: {
      control: {
        borderRadius: 'sm'
      }
    }
  }
};

export default themeCheckboxComponent;
